import { useEffect, useRef } from "react";
import { useState } from "react";
import { Arrow, useLayer } from "react-laag";
import Icon from "../Icon";
import { FuzzyRange } from "./FuzzyRange";
import { useTooltip } from "../hooks/useTooltip";

import "../../styles/fuzzy/fuzzyThreshold.css";
import { Button } from "../buttons/Button";

export { FuzzyThreshold };

// TODO: where is setting state when component unmounted ??
type Props = {
  threshold: number;
  update(threshold: number): void;
  altText?: string;
};
const FuzzyThreshold = (props: Props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [threshold, setThreshold] = useState<number>(props.threshold);

  const {
    renderLayer,
    triggerProps,
    layerProps,
    arrowProps,
    layerSide,
    setOpen,
    isOpen,
  } = useTooltip(
    buttonRef,
    () => {
      props.update(threshold);
      setOpen(false);
    },
    // attach to button
    (disappearType) => {
      if (disappearType == "full") {
        props.update(threshold);
        setOpen(false);
      }
    },
    () => {
      props.update(threshold);
      setOpen(false);
    },
  );

  // update state threshold
  useEffect(() => {
    setThreshold(props.threshold);
  }, [props.threshold]);

  // TODO: useCallback and useState ?? https://medium.com/welldone-software/usecallback-might-be-what-you-meant-by-useref-useeffect-773bc0278ae
  useEffect(() => {
    // call react-laag triggerRef, otherwise error !
    triggerProps?.ref(buttonRef.current);
  }, [buttonRef, buttonRef?.current]);

  return (
    <>
      <Button
        {...triggerProps}
        ref={buttonRef}
        onClick={() => setOpen(!isOpen)}
        className={"fuzzyThreshold white"}
      >
        {`${threshold}%`}
        <Icon
          altText={props.altText ?? "Change Fuzzy Threshold"}
          icon={"cog"}
        />
      </Button>
      {isOpen &&
        renderLayer(
          <div
            {...layerProps}
            style={{
              ...layerProps.style,
              // add merge properties here
            }}
            className={"tooltip " + layerSide}
          >
            <FuzzyRange
              label={"Fuzzy"}
              value={threshold}
              inputLabel
              onChange={(newThreshold) => {
                setThreshold(newThreshold);
                props.update(newThreshold);
                setOpen(false);
              }}
              onMove={(threshold) => setThreshold(threshold)}
            />
            <Arrow
              className={"arrow " + layerSide}
              {...arrowProps}
              size={5}
              roundness={0}
            />
          </div>,
        )}
    </>
  );
};
